import React from "react";
const DownloadIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13v4a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4h1v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4h1Zm6 .293V5h1v8.293l2.146-2.147a.5.5 0 0 1 .708.708L11.5 15.207l-3.354-3.353a.5.5 0 0 1 .708-.708L11 13.293Z"
  }
));
export {
  DownloadIcon
};
//# sourceMappingURL=download-icon.js.map
